import $ from 'jquery';
import skrollr from 'skrollr';
import { initSiv, updateSiv } from 'rytm-helpers';
import { initMaps } from './map';


let s = false;

const onToggleClass = (e) => {
  e.preventDefault();
  const btn = e.currentTarget;
  const className = btn.dataset.toggleClass;
  if (className) {
    document.documentElement.classList.toggle(className);
  }
};

export const initCommon = () => {
  initSiv({ singleShotMode: false });
  $('body').on('click', '*[data-toggle-class]', onToggleClass);
  $(document).on('DOMContentLoaded load', windowUpdate);
  $(window).on('resize', windowUpdate);
  windowUpdate();
  moveUpAndBelow();
  if (!isMobile()) {
    s = skrollr.init({ forceHeight: false });
  }
};


const windowUpdateTimer = false;

export const windowUpdate = (e) => {
  skrollrRefresh();
  updateSiv();
  initMaps();
  moveUpAndBelow();
  // single shots:
  // clearTimeout(windowUpdateTimer)
  // windowUpdateTimer = setTimeout(() => {
  //   moveUpAndBelow()
  // }, 300)
};


const isMobile = () => window.innerWidth <= 768;

const skrollrRefresh = () => {
  if (!isMobile()) {
    if (!s) {
      s = skrollr.init({ forceHeight: false });
    } else {
      s.refresh($('.skrollr-element'));
    }
  } else if (s) {
    s.destroy();
  }
};



// ujemne górne marginesy dla elementów wyświetlanych w układzie przypominającym masonry
const moveUpAndBelow = () => {
  const list = document.querySelectorAll('*[data-move-up]');
  const list2 = document.querySelectorAll('*[data-move-below]');
  const all = document.querySelectorAll('*[data-move-up], *[data-move-below]');
  // reset
  all.forEach((el, index) => {
    el.style.marginTop = 0;
  });
  list.forEach((el, index) => {
    moveElementUp(el);
  });
  list2.forEach((el, index) => {
    moveElementBelow(el);
  });
};

const moveElementUp = (el) => {
  const selector = el.dataset.moveUp;
  const target = selector ? document.querySelector(selector) : false;
  if (target) {
    const h = target.offsetHeight;
    el.style.marginTop = `${-h / 2}px`;
  }
};
const moveElementBelow = (el) => {
  const selector = el.dataset.moveBelow;
  const target = selector ? document.querySelector(selector) : false;
  if (target) {
    const targetRect = target.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    const dif = targetRect.bottom - elRect.top;
    el.style.marginTop = `${Math.round(dif)}px`;
  }
};
